import React, { useState, useEffect, FC } from 'react';
import classnames from 'classnames';
import Svg from 'svg-inline-react';
import starSvg from '@src/svgs/fr-star.svg';
import { RatingColor } from './enums/ratingColor.enum';
import { RatingSize } from './enums/ratingSize.enum';
import { RatingProps } from './props';
import './styles.scss';

export const Rating: FC<RatingProps> = ({
  id,
  maxRating,
  size = RatingSize.LARGE,
  result,
  setResult,
  hasBackground,
  wrapperClassName,
  activeColor = RatingColor.YELLOW,
  isDisabled,
  shouldDisplayOnlyActiveStars,
}) => {
  const setData = (maxRating: number, result: number, shouldDisplayOnlyActiveStars?: boolean) => {
    const rating = [];

    const max = shouldDisplayOnlyActiveStars ? result : maxRating;

    for (let index = 1; index <= max; index++) {
      rating.push({
        rating: index,
        selected: index <= result,
      });
    }

    return rating;
  };

  const [rating, setRating] = useState(() => {
    const initState = setData(maxRating, result, shouldDisplayOnlyActiveStars);

    return initState;
  });

  function handleMouseEnter(rating: { rating: number }[], number: number) {
    const result = rating.map(item => ({
      ...item,
      selected: item.rating <= number,
    }));

    setRating(result);
  }

  const handleMouseLeave = (maxRating: number, result: number) => {
    setRating(setData(maxRating, result));
  };

  const classes = classnames(
    'fr-rating',
    hasBackground && 'fr-rating--with-background',
    wrapperClassName,
    `fr-rating--${size}`,
  );

  useEffect(() => {
    setRating(setData(maxRating, result, shouldDisplayOnlyActiveStars));
  }, [result]);

  return (
    <div className={classes}>
      {rating.map(item => {
        return (
          <span
            className={classnames({
              [`fr-rating--selected-${activeColor}`]: item.selected,
            })}
            key={item.rating}
            onClick={e => {
              e.stopPropagation();

              !isDisabled && setResult?.(item.rating, id);
            }}
            onMouseEnter={() => !isDisabled && handleMouseEnter(rating, item.rating)}
            onMouseLeave={() => !isDisabled && handleMouseLeave(maxRating, result)}
          >
            <Svg src={starSvg} />
          </span>
        );
      })}
    </div>
  );
};
